
import React from 'react';

interface AppStateBackgroundProps {
    isVisible: boolean;
    title?: string;
    message?: string;
    onManageSubscription: () => void;
}

const AppStateBackground: React.FC<AppStateBackgroundProps> = ({
    isVisible,
    title,
    message,
    onManageSubscription
}) => {
    if (!isVisible) return null;

    return (
        <div style={{
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            backdropFilter: 'blur(5px)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
        }}>
            <h2 style={{ marginBottom: '16px', fontSize: '24px', color: '#333' }}>
                {title || "Your subscription has expired."}
            </h2>
            <p style={{ marginBottom: '24px', fontSize: '16px', color: '#666', textAlign: 'center' }}>
                {message || "Please renew your subscription to continue using the app."}
            </p>
        </div>
    );
};

export default AppStateBackground;